// extracted by mini-css-extract-plugin
module.exports = {"container":"MainPage_container__2gyL_","inner":"MainPage_inner__1K78r","metricButtons":"MainPage_metricButtons__ArZto"};